import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import './manageItemUpdatedData.css';

const HomepageDataPieChart = () => {
  const [title, setTitle] = useState('');
  const [graphType, setGraphType] = useState('Only Table');
  const [file, setFile] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [entries, setEntries] = useState(10);

  const navigate = useNavigate();

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleGraphTypeChange = (e) => {
    setGraphType(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = (e) => {
    e.preventDefault();
    // Handle file upload logic here
    console.log({ title, graphType, file });
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleEntriesChange = (e) => {
    setEntries(parseInt(e.target.value, 10));
  };

  const columns = [
    {
      name: 'Milestone Name',
      selector: row => row.milestoneName,
      sortable: true,
    },
    {
      name: 'Planned Date',
      selector: row => row.plannedDate,
      sortable: true,
    },
    {
      name: 'Actual/Anticipated Date',
      selector: row => row.actualDate,
      sortable: true,
    },
  ];

  const data = [
    { id: 1, milestoneName: 'Start', plannedDate: '1/10/2022', actualDate: '1/10/2022' },
    { id: 2, milestoneName: 'CTE', plannedDate: '8/8/2022', actualDate: '8/8/2022' },
    { id: 3, milestoneName: 'Civil Finish', plannedDate: '10/11/2023', actualDate: '12/7/2023' },
    { id: 4, milestoneName: 'Mechanical Finish', plannedDate: '11/10/2023', actualDate: '3/5/2024' },
    { id: 5, milestoneName: 'E&I Finish', plannedDate: '11/10/2023', actualDate: '4/9/2024' },
    { id: 6, milestoneName: 'Kiln Light up', plannedDate: '11/10/2023', actualDate: '4/11/2023' },
  ];

  const filteredData = data.filter(item =>
    item.milestoneName.toLowerCase().includes(searchText.toLowerCase()) ||
    item.plannedDate.toLowerCase().includes(searchText.toLowerCase()) ||
    item.actualDate.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="formContainer">
      <div className="header">
        <h4>HomePage Data</h4><br />
        <div className="buttons">
          <button className="backButton" onClick={handleBackClick}>Back</button>
        </div>
      </div>
      <form className="uploadForm" onSubmit={handleUpload}>
        <div className="formGroup">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={handleTitleChange}
            placeholder="Title"
          />
        </div>
        <div className="formGroup">
          <label htmlFor="graphType">Graph Type</label>
          <select id="graphType" value={graphType} onChange={handleGraphTypeChange}>
            <option value="Only Table">Only Table</option>
            <option value="Bar Graph">Bar Graph</option>
            <option value="Line Graph">Line Graph</option>
            <option value="Pie Chart">Pie Chart</option>
          </select>
        </div>
        <div>
          <label htmlFor="checkbox">Is it milestone?</label>&emsp;
          <input type="checkbox" id="checkbox"/>
        </div>
        <div className="formGroup">
          <label htmlFor="file">Excel Upload</label>
          <div className="fileInputWrapper">
            <input type="file" id="file" onChange={handleFileChange} />
            <label htmlFor="file" className="customFileInput">
              Choose File
            </label>
            {file && <span className="fileName">{file.name}</span>}
          </div>
        </div>
        <button type="submit" className="uploadButton">Save</button>
      </form>

      <div className="chart">
        <span>Chart type: Only Table</span><br/>
        <span className="pieBtn">
          <button>Delete</button>
          <button style={{background: "#2b9ac9"}} onClick={()=>navigate("/homepageedit")}>Edit</button>
        </span>
      </div>

      {/* DataTable */}
      <DataTable
        // title="Milestone Data"
        columns={columns}
        data={filteredData}
        pagination
        paginationPerPage={entries}
        highlightOnHover
        subHeader
        subHeaderComponent={
          <div style={{ width: '100%', marginTop:"20px" }} className='dataTableContainer'>
            
            <div>
              <label htmlFor="selectorInput"><b>Show</b></label>&ensp;
                <select id="selectorInput" style={{ width: "65px" }}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                </select>&ensp;
                entries
            </div>

            <div>
                        <label htmlFor="selectorInput"><b>Search: </b></label>&ensp;
                        <input
                            type="text"
                            placeholder="Search"
                            // value={searchKeyword}
                            // onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                    </div>

          </div>
        }
      />
    </div>
  );
};

export default HomepageDataPieChart;
